import { createNames } from "../../utils";
export const getAceToggleButtonNames = (id) => {
    return createNames(id, 'ACE-TOGGLE-BUTTON', '____DEFAULT', '____HIDDEN', '____DEFAULT____ACTIVE', '____HIDDEN____ACTIVE', '____CIRCULAR', '____FULL_WIDTH', '____FULL_WIDTH_MOBILE', '____FULL_WIDTH_TABLET', '____SIZE_SMALL', '____SIZE_REGULAR');
};
//# sourceMappingURL=ace-toggle-button.get-names.js.map
